import Link from "next/link";

import WeglotNoTranslationWrapper from "@stadium/services/weglot/no-translation-wrapper";

import { useStoreContext } from "@components/store/provider";
import { getBrandRoute } from "@constants/routes";

import { useProductInfoContext } from "@contexts/product-info-context";
import { useCreateSwagContext } from "@contexts/create-swag-context";

import styles from "./main.module.scss";

const ProductDetailHeader = ({
  displayPrice,
  minPoints,
  showProductName,
  displayTotalPrice,
  product,
}) => {
  const { name, brand } = product;

  const { hideBrandLink } = useProductInfoContext();

  const { storeBasePath } = useStoreContext();
  const { isSwagCreationShopFlow } = useCreateSwagContext();
  const brandName = brand?.displayName;

  return (
    <>
      {Boolean(brandName) &&
        (!hideBrandLink ? (
          <Link
            className={`${styles.brandTextLink} cmn-brand-text-link`}
            prefetch={false}
            href={getBrandRoute({
              brandSlug: brand?.key,
              storeBasePath,
            })}
          >
            {brandName}
          </Link>
        ) : (
          <div className={styles.brandText}>{brandName}</div>
        ))}

      <div
        className={`${styles.nameWithPriceRow} ${isSwagCreationShopFlow ? styles.swagNameRow : ""}`}
        area-labelledby="title"
        aria-describedby="price"
        tabIndex="0"
      >
        {(showProductName || name) && (
          <h1 className={`${styles.h1Heading} h1Heading`} id="title">
            {name}
            {minPoints && (
              <>
                <span className={`${styles.divider} divider`} />
                <span className="t-cl-1">Minimum {minPoints}</span>
              </>
            )}
          </h1>
        )}

        {displayPrice ? (
          <p className={`${styles.displayPrice} modalDisplayPrice`} id="price">
            <WeglotNoTranslationWrapper>{displayPrice}</WeglotNoTranslationWrapper>
            {displayTotalPrice ? (
              <>
                <span className={styles.modalPriceSap}>|</span>
                <span className={styles.totalPrice}>
                  <WeglotNoTranslationWrapper>{displayTotalPrice}</WeglotNoTranslationWrapper> total
                </span>
              </>
            ) : null}
          </p>
        ) : null}
      </div>
    </>
  );
};

export default ProductDetailHeader;
